import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchSegmap } from "../data/actions";
import * as select from "../data/selectors";
import { Grid, Button, Icon } from "semantic-ui-react";
import { heightSet } from "../../../utilities/heightSet";
import { searchColumns } from "../data/model";
import { TableListDiv } from "../../../utilities/tableListDiv";

const SegmapList = (props) => {
  const dispatch = useDispatch();
  const segmap = useSelector((state) => select.getFilteredSegmap(state));
  const [heights, setHeight] = useState("");

  useEffect(() => {
    dispatch(fetchSegmap());
  }, [dispatch]);

  const callHeightFunc = () => {
    heightSet(setHeight);
  };

  useEffect(() => {
    callHeightFunc();
    window.addEventListener("resize", callHeightFunc, false);
    return () => {
      window.removeEventListener("resize", callHeightFunc);
    };
  }, []);

  const segmapAction = ({ object: segmap }) => {
    return (
      <>
        <Link to={"/segmap/edit/" + segmap.id} title="Edit">
          <Icon name="edit" color="blue" link />
        </Link>
        <span style={{ color: "#cfd8e3", margin: "0 6px" }}>|</span>
        <Link to={"/segmap/clone/" + segmap.id} title="Clone">
          <Icon name="copy outline" color="teal" link />
        </Link>
      </>
    );
  };
  const redirectToAddSegmap = () => {
    props.history.push({ pathname: "/segmap/create" });
  };

  return (
    <>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 4px 12px",
      }}>
        <div>
          <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
            Segment Map
          </div>
          <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
            Manage DMS to RealBooks segment mapping.
          </div>
        </div>
        <Button
          onClick={redirectToAddSegmap}
          type="button"
          color="blue"
          size="small"
          icon
          labelPosition="left"
        >
          <Icon name="plus" />
          Add Segment
        </Button>
      </div>
      <div className="" style={{ paddingTop: "10px" }}>
        <TableListDiv
          columns={searchColumns}
          data={segmap}
          Actions={segmapAction}
          setHeight={parseFloat(heights) - 180}
          getIndex={7}
          filterBoxNone={""}
          rightBox={""}
          centerBox={""}
          callHeightFunc={callHeightFunc}
          paddingShort={2}
          getWidth={"100%"}
          actionClass={"segmapActionTdDR"}
        />
      </div>
    </>
  );
};

export default SegmapList;
